/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebfielddescription3Inputs */

const en_placewebfielddescription3 = /** @type {(inputs: Placewebfielddescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const de_placewebfielddescription3 = /** @type {(inputs: Placewebfielddescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Placewebfielddescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebfielddescription3 = /** @type {((inputs?: Placewebfielddescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebfielddescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebfielddescription3(inputs)
	return de_placewebfielddescription3(inputs)
});
export { placewebfielddescription3 as "placeWebFieldDescription" }